import { RECRUITERCANDIDATEDETAILS } from "../../ENVIRONMENT";

// api for recruiter candidate list sorting
async function candidateListSorting(token, currentPage, name, order) {
  const response = await fetch(
    RECRUITERCANDIDATEDETAILS + `?limit=6&page=${currentPage}&${name}=${order}`,
    {
      headers: {
        "Content-Type": "Application/json",
        Authorization: `Bearer ${
          token ? token : sessionStorage.getItem("token")
        }`,
      },
    }
  );
  return response;
}

export { candidateListSorting };
